import Api from '@/services/Api'

export default {
  register (credentials) {
    return Api().post('/players/', credentials)
  },
  login (credentials) {
    return Api().post('/jwt/obtain/', credentials)
  }
}
